import React, { useState, useEffect } from 'react';
import { AdminQuestionItem } from '../../pages/Assessment/quizData'; // Sesuaikan path import
import api from '../../utils/api';

const CreateQuestionContent: React.FC = () => {
  // ... (State awal sama seperti sebelumnya) ...
  const [questionType, setQuestionType] = useState('multiple_choice');
  const [isEditing, setIsEditing] = useState<number | null>(null);

  const initialFormState = {
    questionNumber: 1,
    category: 'Basic', 
    type: 'multiple_choice',
    questionText: '',
    optionA: '',
    optionB: '',
    optionC: '',
    optionD: '',
    correctAnswer: 'A',
    referenceAnswer: '',
    audioText: ''
  };

  const [questionData, setQuestionData] = useState(initialFormState);
  const [questionsList, setQuestionsList] = useState<AdminQuestionItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        const response = await api.get('/questions');
        setQuestionsList(response.data.data || []);
      } catch (error) {
        console.error('Gagal mengambil soal:', error);
        alert('Gagal mengambil soal dari database.');
      } finally {
        setIsLoading(false);
      }
    };

    loadQuestions();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setQuestionData(prev => ({ ...prev, [name]: value }));
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const type = e.target.value;
    setQuestionType(type);
    setQuestionData(prev => ({ ...prev, type: type }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const payload = { ...questionData, type: questionType };
      if (isEditing !== null) {
        const response = await api.put(`/questions/${isEditing}`, payload);
        setQuestionsList(prev => prev.map(item => item.id === isEditing ? response.data.data : item));
        alert('Soal berhasil diperbarui!');
        setIsEditing(null);
      } else {
        const response = await api.post('/questions', payload);
        setQuestionsList(prev => [response.data.data, ...prev]);
        alert('Soal berhasil ditambahkan!');
      }

      setQuestionData(initialFormState);
      setQuestionType('multiple_choice');
    } catch (error) {
      console.error('Gagal menyimpan soal:', error);
      alert('Gagal menyimpan soal ke database.');
    }
  };

  const handleEdit = (id: number) => {
    const itemToEdit = questionsList.find(q => q.id === id);
    if (itemToEdit) {
      setQuestionData({
        questionNumber: itemToEdit.questionNumber,
        category: itemToEdit.category,
        type: itemToEdit.type,
        questionText: itemToEdit.questionText,
        optionA: itemToEdit.optionA,
        optionB: itemToEdit.optionB,
        optionC: itemToEdit.optionC,
        optionD: itemToEdit.optionD,
        correctAnswer: itemToEdit.correctAnswer,
        referenceAnswer: itemToEdit.referenceAnswer,
        audioText: itemToEdit.audioText || ''
      });
      setQuestionType(itemToEdit.type);
      setIsEditing(id);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Yakin ingin menghapus soal ini?')) {
      try {
        await api.delete(`/questions/${id}`);
        setQuestionsList(prev => prev.filter(q => q.id !== id));
      } catch (error) {
        console.error('Gagal menghapus soal:', error);
        alert('Gagal menghapus soal dari database.');
      }
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(null);
    setQuestionData(initialFormState);
    setQuestionType('multiple_choice');
  };

  // --- STYLES (Sama seperti sebelumnya) ---
  const styles = {
    // ... Copy styles dari kode sebelumnya ...
    container: { backgroundColor: 'white', padding: '30px', borderRadius: '15px', boxShadow: 'var(--card-shadow)' },
    headerTitle: { fontSize: '24px', fontWeight: '700', marginBottom: '25px', color: 'var(--primary-dark)', borderBottom: '2px solid var(--border-color)', paddingBottom: '10px' },
    formGroup: { marginBottom: '20px' },
    label: { display: 'block', marginBottom: '8px', fontWeight: '600', color: 'var(--text-dark)' },
    input: { width: '100%', padding: '12px', border: '1px solid var(--border-color)', borderRadius: '8px', fontSize: '14px', outline: 'none' },
    textarea: { width: '100%', padding: '12px', border: '1px solid var(--border-color)', borderRadius: '8px', fontSize: '14px', minHeight: '100px', outline: 'none', fontFamily: 'inherit' },
    select: { width: '100%', padding: '12px', border: '1px solid var(--border-color)', borderRadius: '8px', fontSize: '14px', backgroundColor: 'white' },
    buttonSave: { backgroundColor: isEditing ? '#f39c12' : 'var(--primary-color)', color: 'white', padding: '14px 28px', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '16px', marginTop: '10px', display: 'inline-flex', alignItems: 'center', gap: '8px', marginRight: '10px' },
    buttonCancel: { backgroundColor: '#95a5a6', color: 'white', padding: '14px 28px', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '16px', marginTop: '10px' },
    tableContainer: { marginTop: '50px', overflowX: 'auto' as 'auto' },
    table: { width: '100%', borderCollapse: 'collapse' as 'collapse', marginTop: '15px' },
    th: { backgroundColor: '#f8f9fa', padding: '15px', textAlign: 'left' as 'left', borderBottom: '2px solid #ddd', color: '#555', fontWeight: '600' },
    td: { padding: '15px', borderBottom: '1px solid #eee', color: '#333' },
    actionBtn: { padding: '8px 12px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px', color: 'white', marginLeft: '5px' },
  };

  return (
    <div style={styles.container}>
       {/* ... (JSX FORM SAMA SEPERTI SEBELUMNYA) ... */}
       {/* Audio masih berupa teks yang dibacakan oleh browser. */}
       
       <h3 style={styles.headerTitle}><i className={`fas ${isEditing ? 'fa-edit' : 'fa-file-pen'}`}></i> {isEditing ? 'Edit Soal' : 'Form Input Soal'}</h3>
       
       <form onSubmit={handleSubmit}>
        <div style={styles.formGroup}>
            <label style={styles.label}>Nomor Soal</label>
            <input type="number" name="questionNumber" min="1" value={questionData.questionNumber} onChange={handleChange} style={styles.input} required />
        </div>
        <div style={styles.formGroup}>
            <label style={styles.label}>Jenis Soal</label>
            <select name="type" value={questionType} onChange={handleTypeChange} style={styles.select} disabled={isEditing !== null}>
                <option value="multiple_choice">Pilihan Ganda</option>
                <option value="listening">Listening</option>
                <option value="essay">Essay</option>
            </select>
        </div>

        {questionType === 'listening' && (
             <div style={styles.formGroup}>
                <label style={styles.label}>Teks Audio (Untuk Simulasi Suara)</label>
                <input type="text" name="audioText" value={questionData.audioText} onChange={handleChange} placeholder="Masukkan teks yang akan dibacakan robot..." style={styles.input} />
             </div>
        )}

        <div style={styles.formGroup}>
            <label style={styles.label}>Pertanyaan</label>
            <textarea name="questionText" value={questionData.questionText} onChange={handleChange} style={styles.textarea} required />
        </div>

        {(questionType === 'multiple_choice' || questionType === 'listening') && (
            <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={styles.formGroup}><label style={styles.label}>Opsi A</label><input type="text" name="optionA" value={questionData.optionA} onChange={handleChange} style={styles.input} required /></div>
                <div style={styles.formGroup}><label style={styles.label}>Opsi B</label><input type="text" name="optionB" value={questionData.optionB} onChange={handleChange} style={styles.input} required /></div>
                <div style={styles.formGroup}><label style={styles.label}>Opsi C</label><input type="text" name="optionC" value={questionData.optionC} onChange={handleChange} style={styles.input} required /></div>
                <div style={styles.formGroup}><label style={styles.label}>Opsi D</label><input type="text" name="optionD" value={questionData.optionD} onChange={handleChange} style={styles.input} required /></div>
            </div>
            <div style={styles.formGroup}>
                <label style={styles.label}>Kunci Jawaban</label>
                <select name="correctAnswer" value={questionData.correctAnswer} onChange={handleChange} style={styles.select}>
                <option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option>
                </select>
            </div>
            </>
        )}

        {questionType === 'essay' && (
            <div style={styles.formGroup}>
            <label style={styles.label}>Kunci Jawaban (Referensi)</label>
            <textarea name="referenceAnswer" value={questionData.referenceAnswer} onChange={handleChange} style={{...styles.textarea, minHeight: '80px'}} />
            </div>
        )}

        <button type="submit" style={styles.buttonSave}><i className="fas fa-save"></i> {isEditing ? 'Update' : 'Simpan'}</button>
        {isEditing && <button type="button" onClick={handleCancelEdit} style={styles.buttonCancel}>Batal</button>}
       </form>

       <div style={styles.tableContainer}>
        <h3>Riwayat Soal (Tersimpan)</h3>
        <table style={styles.table}>
            <thead><tr><th style={styles.th}>No</th><th style={styles.th}>Soal</th><th style={styles.th}>Aksi</th></tr></thead>
            <tbody>
                {isLoading ? (
                    <tr><td style={styles.td} colSpan={3}>Memuat soal...</td></tr>
                ) : questionsList.map((q, idx) => (
                    <tr key={q.id}>
                        <td style={styles.td}>{q.questionNumber}</td>
                        <td style={styles.td}>{q.questionText}</td>
                        <td style={styles.td}>
                            <button onClick={() => handleEdit(q.id)} style={{...styles.actionBtn, backgroundColor: '#f39c12'}}>Edit</button>
                            <button onClick={() => handleDelete(q.id)} style={{...styles.actionBtn, backgroundColor: 'red'}}>Hapus</button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
       </div>
    </div>
  );
};
export default CreateQuestionContent;